import script from "./AppointList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointList.vue?vue&type=script&setup=true&lang=ts"

import "./AppointList.vue?vue&type=style&index=0&id=1cc966be&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc966be"]])

export default __exports__